import PropTypes from "prop-types";
import React from "react";
import Download from "../../../assets/assets/nip-download.svg";
import File from "../../../assets/assets/file.svg";
import Button from "../../Button/Button";

const KitDownload = (props) => {
  const { goToNext } = props;

  const documents = [
    {
      name: "NIP API documentation",
      value: "nip_api_doc.pdf",
    },
    {
      name: "Key Encryption and Decryption Flow",
      value: "key_encryption_decryption_flow.pdf",
    },
    {
      name: "NIP Outward and Inward Flow Diagram",
      value: "flow_diagram.pdf",
    },
    {
      name: "NIP Compiled Procedure For Testing",
      value: "nip_compiled_test_procedure.pdf",
    },
    {
      name: "NIP Operation Guide",
      value: "operation_guide.pdf",
    },
    {
      name: "NIP Implementation Plan",
      value: "nip_implementation_plan.pdf",
    },
    {
      name: "NIP Public Keys",
      value: "nibss_public.key",
    },
  ];

  return (
    <div className="kit-download">
      <div>
        <div className="kit-download-top">
          <div className="nip-integration-header">
            Download NIP Implementation Kit
          </div>
          <a
            href={`${process.env.REACT_APP_API_KIT_LINK}/all_kit.zip`}
            className="kit-download-top-right-link"
            data-testid="downloadAllKit"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="kit-download-top-right">
              <div className="kit-download-top-right-image">
                <img src={Download} alt="download-icon" />
              </div>
              <span className="kit-download-top-right-text">
                Download all attachment
              </span>
            </div>
          </a>
        </div>

        <div className="kit-download-bottom">
          {documents &&
            documents.map((item, index) => (
              <div className="kit-download-bottom-box" key={index}>
                <h1>{item.name}</h1>
                <div className="inner-box">
                  <span>
                    <img src={File} alt="file" /> &nbsp; {item.value}
                  </span>
                  <a
                    href={`${process.env.REACT_APP_API_KIT_LINK}/${item.value}`}
                    data-testid={`downloadAllSingleKit${index}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    <div className="icon-download">
                      <img src={Download} alt="downlaod-icon" />
                    </div>
                  </a>
                </div>
              </div>
            ))}
        </div>

        <div className="kit-download-button">
          <Button
            className="button"
            type="submit"
            width="35%"
            height="50px"
            testId="goToNext"
            text="Proceed"
            onClick={() => goToNext()}
          />
        </div>
      </div>
    </div>
  );
};

KitDownload.propTypes = {
  downloadNipKit: PropTypes.func,
  getKitSuccess: PropTypes.any,
  getNipKit: PropTypes.func,
  goToNext: PropTypes.func,
  isDownloading: PropTypes.any,
  isGetting: PropTypes.any,
  kit: PropTypes.shape({
    flow_diagram: PropTypes.any,
    key_encryption_decryption_flow: PropTypes.any,
    nip_api_doc: PropTypes.any,
    nip_compiled_test_procedure: PropTypes.any,
    operation_guide: PropTypes.any,
    public_key: PropTypes.any,
  }),
};

export default KitDownload;
